class CustomBundleProduct extends HTMLElement {
  constructor() {
    super();
    this._inited = false;
    this._selectionCounter = 0;
    this.onSizePackChange = this.onSizePackChange.bind(this);
    this.onPlusMinusClick = this.onPlusMinusClick.bind(this);
    this.onMediaClick = this.onMediaClick.bind(this);
    this.onPopupClose = this.onPopupClose.bind(this);
    this.repaintQueued = false;
    
  }   

  connectedCallback() {
    const observer = new IntersectionObserver((entries, obs) => {
      if (!entries[0]?.isIntersecting) return;
      obs.unobserve(entries[0].target);
      if (!this._inited) this.init();
    }, { rootMargin: "0px 0px 300px 0px" });
    observer.observe(this);
  }                      

  init() {
    var this2 = this;
    this.$doc = $(document);
    this.$root = $(this);
    this.$selectedWrapperAll = $('.selected-packs-wrapper');
    this.$selectedContainerAll = $('.selected-packs');
    //this.restorePackSize();
    this.updateWrapperAndContainer();
    
    this.$doc
      .off('change.sizepack', 'input[name="size-pack"]')
      .on('change.sizepack', 'input[name="size-pack"]', this.onSizePackChange)
      .off('click.plusminus', '.custom-product-selector-plus, .custom-product-selector-minus')
      .on('click.plusminus', '.custom-product-selector-plus, .custom-product-selector-minus', this.onPlusMinusClick)
      .off('click.mediapopup', '.custom-product-selector-item .custom-selector-product-media')
      .on('click.mediapopup', '.custom-product-selector-item .custom-selector-product-media', this.onMediaClick)
      .off('click.popupclose', '.popup-description-wrapper .popup-cross-button, .popup-information-overlay')
      .on('click.popupclose', '.popup-description-wrapper .popup-cross-button, .popup-information-overlay', this.onPopupClose);
     
     $('.custom-product-selector-input').val(0).attr('min', 0);
    //this.restoreSelPack();
     this.setPrices();
      $('input[name="product-subscription"]').change(function(){
        this2.setPrices();
      })
       $('.custom-atc-btn-checkout').find('span').show();
      $('.custom-atc-btn-checkout').find('.loading__spinner').addClass('hidden');
     $('.custom-atc-btn-checkout').click(async function() {
        try {
          var this3 = this;
       $(this).find('span').hide();
        $(this).find('.loading__spinner').removeClass('hidden');
        const bundleProductData = {
          productId: $('input[name="size-pack"]:checked').attr('data-productid'),
          variantId: $('input[name="size-pack"]:checked').attr('data-variant'), 
          handle: $('input[name="size-pack"]:checked').attr('data-handle'),
        };
        if($('input[name="product-subscription"]:checked').val() == 'susbscribe-and-save'){
          bundleProductData['sellingPlan'] = $('.selling_plan_select_container').val();
        }

        const bundle = {
          externalVariantId: bundleProductData.variantId,
          externalProductId: bundleProductData.productId, 
        };
           
        var selections = [];
        var selectionstr = '';  
        $('.custom-product-selector-input').each(function(){
            if($(this).val() > 0){
              var rawData = $(this).parents('.custom-product-selector-item').find('.variants-data').html();
              var doc = new DOMParser().parseFromString(rawData, "text/html");
              rawData = doc.body.textContent || doc.body.innerText;  // Extract plain text after decoding
              var product = JSON.parse(rawData);
              const label = $('.selling_plan_select_container').find('option:selected').attr('data-name');
              const varid = $(this).attr('data-varid-pack');
              const sellingPlanId = this2.getSellingPlanIdForLabel(product, varid, label);
              const selitem = {
                collectionId: '509349921070',
                externalProductId: $(this).attr('data-productid'),
                externalVariantId: varid,
                quantity: Number($(this).val()),  
              }
              if($('input[name="product-subscription"]:checked').val() == 'susbscribe-and-save'){
                selitem['sellingPlan'] = sellingPlanId;
              }
              selectionstr =selectionstr + '\n' + $(this).val() + 'x '+$(this).parents('.custom-product-selector-item').find('.custom-selector-product-title').html();  
              selections.push(selitem);
            }
        })
        bundle['selections'] = selections;
         // alert('working' + JSON.stringify(selections))
        
        const rbId = await recharge.bundle.getBundleId(bundle);
        const isValid = await recharge.bundle.validateBundleSelection(bundle);
        const cartItems = await recharge.bundle.getDynamicBundleItems(bundle, bundleProductData.handle);
        const cartData = { items: cartItems };
         console.log(bundle) 
         console.log(cartData) 
        console.log(rbId)
      
        console.log(isValid)  
         
        
        if(isValid.valid === true){

           var properties = {
            'Contents':  selectionstr.substring(1),
            "_rb_id": rbId
           }  

           var sellplan = '';

           if($('input[name="product-subscription"]:checked').val() == 'susbscribe-and-save'){
              sellplan = $('.selling_plan_select_container').val();
           }

           $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              contentType: 'application/json; charset=utf-8',
              data: JSON.stringify({
                items: [
                  { 
                    id: $('input[name="size-pack"]:checked').attr('data-variant'), 
                    quantity: 1, 
                    selling_plan: sellplan,
                    properties: properties
                  }
                ]
              }),
              success: function(data){  
                 $('.custom-atc-btn-checkout').find('span').show();
                  $('.custom-atc-btn-checkout').find('.loading__spinner').addClass('hidden');
                  window.location.href = '/cart';
              },
              error: function(xhr){
                 $('.custom-atc-btn-checkout').find('span').show();
                 $('.custom-atc-btn-checkout').find('.loading__spinner').addClass('hidden');
                let msg = 'Add to cart failed';
                try {
                  const res = JSON.parse(xhr.responseText);
                  msg = res.description || res.message || msg;
                  alert(msg);
                } catch(e){}
                onError({ status: xhr.status, message: msg, raw: xhr });
              }
            });
             
         
        }
        }
        catch(err) {
         alert(err.message);
        }
        
      });


    this._inited = true;
    const $checked = $('input[name="size-pack"]:checked');
    if ($checked.length) {
      this.onSizePackChange({ currentTarget: $checked[0] });
    }
  }

  setPrices(){
    
        const productmain = JSON.parse($('.subscription-packs-container').find('.variant-json').html());
        for (let index = 0; index < productmain.length; index++) {
          const element = productmain[index];
          console.log(element.id)
          console.log($('input[name="size-pack"]:checked').attr('data-variant'))
          if(element.id == Number($('input[name="size-pack"]:checked').attr('data-variant'))){
                
                var disclength = $('body').data('discountper');

                if (typeof disclength !== 'undefined') {
                  var discountMultiplier = disclength / 100;
                  var discountedPrice = Math.round(element.selling_plan_allocations[0].price * discountMultiplier);
                  var discountedcPrice = Math.round(element.selling_plan_allocations[0].compare_at_price * discountMultiplier);
                  var price = (discountedPrice / 100).toFixed(2);
                  var cprice =(discountedcPrice / 100).toFixed(2);

                  $('.susbscribe-save-price').html(Shopify.formatMoney(price));
                  $('.susbscribe-save-cprice').html(Shopify.formatMoney(cprice));
                  $('.one-time-purchase-price').html(Shopify.formatMoney(cprice));

                }else{
                  var price = element.selling_plan_allocations[0].price;
                  var cprice = element.selling_plan_allocations[0].compare_at_price;

                  $('.susbscribe-save-price').html(Shopify.formatMoney(price));
                  $('.susbscribe-save-cprice').html(Shopify.formatMoney(cprice));                
                  price = element.price;
                  $('.one-time-purchase-price').html(Shopify.formatMoney(price)) 
                }
                
                
                console.log(price +"=>"+ cprice);
            
          } 
        }
        if($('input[name="product-subscription"]:checked').val() == 'susbscribe-and-save'){
          $('.perbottle-onetime').hide();
          $('.perbottle-subscription').show();
         
          $('.custom-product-select-pack').each(function(){
            if($(this).find('input').attr('value') == 6){
              var price = productmain[0].selling_plan_allocations[0].price;
               $(this).find('.perbottle-subscription').html(Shopify.formatMoney(price / 6) + '/bottle') 
            }
            if($(this).find('input').attr('value') == 12){
              var price = productmain[1].selling_plan_allocations[0].price;
               $(this).find('.perbottle-subscription').html(Shopify.formatMoney(price / 12) + '/bottle') 
            }
            if($(this).find('input').attr('value') == 24){
              var price = productmain[2].selling_plan_allocations[0].price;
               $(this).find('.perbottle-subscription').html(Shopify.formatMoney(price / 24) + '/bottle') 
            }
          })
        }else{
            $('.perbottle-onetime').show(); 
            $('.perbottle-subscription').hide();    
            $('.custom-product-select-pack').each(function(){
              if($(this).find('input').attr('value') == 6){
                var price = productmain[0].price;
                $(this).find('.perbottle-onetime').html(Shopify.formatMoney(price / 6) + '/bottle') 
              }
              if($(this).find('input').attr('value') == 12){
                var price = productmain[1].price;
                $(this).find('.perbottle-onetime').html(Shopify.formatMoney(price / 12) + '/bottle') 
              }
              if($(this).find('input').attr('value') == 24){
                var price = productmain[2].price;
                $(this).find('.perbottle-onetime').html(Shopify.formatMoney(price / 24) + '/bottle') 
              }
            })
        }
  }

  getSellingPlanIdForLabel(product, variantId, label) { 
    const normalized = label
      .replace(/every\s+other\s+week/i, 'Bi-Weekly Delivery')
      .trim()
      .toLowerCase();
 
    const group = product.selling_plan_groups.find(g =>
      g.name.trim().toLowerCase() === normalized
    );

    if (!group) return null; 

    const variant = product.variants.find(v => String(v.id) === String(variantId));
    if (!variant) return null;
 
    for (const plan of group.selling_plans) {
      const ok = (variant.selling_plan_allocations || []).some(a =>
        String(a.selling_plan_id) === String(plan.id)
      );
      if (ok) return plan.id;  
    }

    return null;
  }

  get packSize() {
    const $checked = $('input[name="size-pack"]:checked');
    const v = $checked.val() || localStorage.getItem('packsize');
    return parseInt(v, 10) || 0;
  }

  set packSize(val) {
    const v = parseInt(val, 10) || 0;
    try { localStorage.setItem('packsize', String(v)); } catch (e) {}
  }

  saveSelPack() {
    const data = [];
    $('.custom-product-selector-item').each(function () {
      const $qty = $(this).find('.custom-product-selector-input');
      const q = parseInt($qty.val(), 10) || 0;
      const id = $qty.attr('data-varid-pack');
      if (id && q > 0) data.push({ id: String(id), qty: q });
    });
    try { localStorage.setItem('selpack', JSON.stringify(data)); } catch (e) {}
  }

  restoreSelPack() {
    let arr = [];
    try {
      arr = JSON.parse(localStorage.getItem('selpack') || '[]') || [];
    } catch (e) { arr = []; }
    arr.forEach((it) => {
      const $q = $('.custom-product-selector-input[data-varid-pack="' + it.id + '"]');
      if ($q.length) {
        const val = parseInt(it.qty, 10) || 0;
        $q.val(val);
        const $item = $q.closest('.custom-product-selector-item');
        $item.find('input[type="checkbox"]').prop('checked', val > 0);
        if (val > 0 && $item.data('sequence') == null) {
          this._selectionCounter += 1;
          $item.data('sequence', this._selectionCounter);
        }
      }
    });
    this.queueRepaint();
    this.saveSelPack();
    this.syncMinusFromSelpack();
    this.updatePlusMinusStates();
  }

  restorePackSize() {
    const saved = localStorage.getItem('packsize');
    if (saved) {
      const $saved = $('input[name="size-pack"][value="' + saved + '"]');
      if ($saved.length) $saved.prop('checked', true);
    } else {
      const $default = $('input[name="size-pack"]:checked');
      if ($default.length) this.packSize = $default.val();
    }
  }

  getCapacity() {
    return this.packSize;
  }

  getTotalSelected() {
    let t = 0;
    $('.custom-product-selector-input').each(function () {
      t += parseInt($(this).val(), 10) || 0;
    });
    return t;
  }

  itemsSortedBySequenceAsc() {
    const $items = $('.custom-product-selector-item').filter(function () {
      return (parseInt($(this).find('.custom-product-selector-input').val(), 10) || 0) > 0;
    });
    return $items.sort((a, b) => {
      const sa = $(a).data('sequence') || 0;
      const sb = $(b).data('sequence') || 0;
      return sa - sb;
    });
  }

  setSequenceIfNeeded($item) {
    if ($item.data('sequence') == null) {
      this._selectionCounter += 1;
      $item.data('sequence', this._selectionCounter);
    }
  }

  clearSequence($item) {
    $item.removeData('sequence');
  }

  syncMinusFromSelpack() {
    let map = {};
    try {
      (JSON.parse(localStorage.getItem('selpack') || '[]') || []).forEach(function (it) {
        map[String(it.id)] = parseInt(it.qty, 10) || 0;
      });
    } catch (e) {}
    $('.custom-product-selector-item').each(function () {
      const $item = $(this);
      const $qty  = $item.find('.custom-product-selector-input');
      const id    = String($qty.attr('data-varid-pack') || '');
      const q     = map[id] || 0;
      $item.find('.custom-product-selector-minus').toggleClass('disabled', q <= 0);
      $item.find('input[type="checkbox"]').prop('checked', q > 0);
    });
  }

  updatePlusMinusStates() {
    const cap = this.getCapacity();
    const total = this.getTotalSelected();
    $('.custom-product-selector-item').each(function () {
      const $item  = $(this);
      const $qty   = $item.find('.custom-product-selector-input');
      const val    = parseInt($qty.val(), 10) || 0;
      const $minus = $item.find('.custom-product-selector-minus');
      const $plus  = $item.find('.custom-product-selector-plus');
      const totalOthers = total - val;
      const allowedForThis = Math.max(0, cap - totalOthers);
      $minus.toggleClass('disabled', val <= 0);
      $plus.toggleClass('disabled', val >= allowedForThis);
    });
  }

  trimToCapacity() {
    const cap = this.getCapacity();
    let total = this.getTotalSelected();
    if (total <= cap) return;
    const $selected = $('.custom-product-selector-item').filter(function () {
      return (parseInt($(this).find('.custom-product-selector-input').val(), 10) || 0) > 0;
    }).sort((a, b) => {
      const sa = $(a).data('sequence') || 0;
      const sb = $(b).data('sequence') || 0;
      return sb - sa;
    });
    $selected.each((_, el) => {
      if (total <= cap) return false;
      const $item = $(el);
      const $qty = $item.find('.custom-product-selector-input');
      let val = parseInt($qty.val(), 10) || 0;
      const remove = Math.min(val, total - cap);
      val -= remove;
      $qty.val(val);
      if (val <= 0) this.clearSequence($item);
      total -= remove;
    });
  }  

  allocateBoxes() {
    const capacity = this.getCapacity();
    const picks = [];
    this.itemsSortedBySequenceAsc().each(function () {
      const $item = $(this);
      const $qty = $item.find('.custom-product-selector-input');
      const qty = parseInt($qty.val(), 10) || 0;
      const variantId = $qty.attr('data-varid-pack');
      const imageUrl = $qty.attr('data-pimg');
      for (let i = 0; i < qty && picks.length < capacity; i++) {
        picks.push({ variantId, imageUrl });
      }
      if (picks.length >= capacity) return false;
    });
    const $wrapper = $('.selected-packs-wrapper:visible');
    const $boxes = $wrapper.find('.selected-item-box');
    const placeholder = 'https://cdn.shopify.com/s/files/1/0809/2516/3822/files/ChatGPT_Image_Sep_17_2025_02_57_50_PM_copynew.png?v=1758102626';
    $boxes.each(function (i) {
      if (i < picks.length) {
        const { variantId, imageUrl } = picks[i];
        $(this)
          .data('variant_id', variantId)
          .attr('data-variant_id', variantId)
          .addClass('filled')
          .find('img').attr('src', imageUrl);
      } else {
        $(this)
          .removeData('variant_id')
          .removeAttr('data-variant_id')
          .removeClass('filled')
          .find('img').attr('src', placeholder);
      }
    });
    var selpack = $('input[name="size-pack"]:checked').attr('value');
    if(selpack == 6 && $('.selected-item-box.filled').length != 6){
        $('.custom-atc-btn-checkout').addClass('disabled');
    }else if(selpack == 12 && $('.selected-item-box.filled').length != 12){
        $('.custom-atc-btn-checkout').addClass('disabled');
    }else if(selpack == 24 && $('.selected-item-box.filled').length != 24){
        $('.custom-atc-btn-checkout').addClass('disabled');
    }else{
         $('.custom-atc-btn-checkout').removeClass('disabled');
    }
  }

  enforceDisable() {}

  queueRepaint() {
    if (this.repaintQueued) return;
    this.repaintQueued = true;
    requestAnimationFrame(() => {
      this.repaintQueued = false;
      this.trimToCapacity();
      this.allocateBoxes();
      this.enforceDisable();
    });
  }

  updateWrapperAndContainer() {
    const size = this.getCapacity();
    this.$selectedWrapperAll.attr('data-wrapper', size);
    this.$selectedContainerAll.attr('data-wrapper-container', size);
    const $boxes = $('.selected-item-box');
    $boxes.removeClass('active').slice(0, size).addClass('active');
    this.queueRepaint();
    this.updatePlusMinusStates();
  }

  onSizePackChange(e) {
    const $radio = $(e.currentTarget);
    this.packSize = $radio.val();
    const varid = $radio.attr('data-variant');
 
    const $wrapper = $('.selling_plan_select_container_product');
    const $sel = $wrapper.is('select') ? $wrapper : $wrapper.find('select');
 
    if (!$sel.data('allOptionsHtml')) {
      $sel.data('allOptionsHtml', $sel.html());
    }
 
    $sel.html($sel.data('allOptionsHtml'));
 
    $sel.find('option').each(function () {
      const $opt = $(this);
      if ($opt.attr('data-varid') !== varid) {
        $opt.remove();
      }
    });
 
    const $visibleOptions = $sel.find('option');

    if ($visibleOptions.length) {
      $sel.val($visibleOptions.first().val()).trigger('change');
    }
    this.setPrices();
    this.updateWrapperAndContainer();
  }

  onPlusMinusClick(e) {
    const $btn  = $(e.currentTarget);
    const $item = $btn.closest('.custom-product-selector-item');
    const $qty  = $item.find('.custom-product-selector-input');
    const was   = parseInt($qty.val(), 10) || 0;
    let val     = was;
    const step  = parseInt($qty.attr('step'), 10) || 1;
    const cap = this.getCapacity();
    let totalOthers = 0;
    $('.custom-product-selector-input').not($qty).each(function () {
      totalOthers += parseInt($(this).val(), 10) || 0;
    });
    if ($btn.hasClass('custom-product-selector-plus')) {
      const maxForThis = Math.max(0, cap - totalOthers);
      val = Math.min(was + step, maxForThis);
    } else {
      val = Math.max(was - step, 0);
    }
    if (val === was) return;
    $qty.val(val);
    if (val > 0 && was === 0) this.setSequenceIfNeeded($item);
    else if (val === 0 && was > 0) this.clearSequence($item);
    this.queueRepaint();
    this.saveSelPack();
    this.syncMinusFromSelpack();
    this.updatePlusMinusStates();
  }

  onMediaClick(e) {
    $(e.currentTarget)
      .parents('.custom-product-selector-item')
      .find('.popup-description-wrapper-main').show();
    $('html').css('overflow', 'hidden');
  }

  onPopupClose(e) {
    $(e.currentTarget)
      .parents('.custom-product-selector-item')
      .find('.popup-description-wrapper-main').hide();
    $('html').css('overflow', 'auto');
  }


}
customElements.define('custom-bundle-product', CustomBundleProduct);


window.addEventListener("pageshow", function(event) {
  if (event.persisted) {
    window.location.reload();
  }
});